const removeNonDigits = (value = '', limit = -1): string => {
  const nonDigits = String(value).replace(/\D/g, '');

  if (limit > 0 && typeof nonDigits === 'string' && nonDigits.length > limit) return nonDigits.substring(0, limit);
  return nonDigits;
};

export default removeNonDigits;
